import Api from '../../services/Api';

const getHorarios = async (tipoEntregaRetirada) => {
    const request = await Api.get(
            `gestao/tipo-entrega-retirada/${tipoEntregaRetirada}/horario` // tipoEntregaRetirada:  1 - entrega  2 - retirada
        ),
        list = request.data;

    return list;
};

const getCfg = async (idTipoEntregaRetirada) => {
    const request = await Api.get(
            `gestao/tipo-entrega-retirada/${idTipoEntregaRetirada}`
        ),
        list = request.data;
    return list;
};

const saveCfg = async (cfg) => {
    try {
        return Api.put(`gestao/tipo-entrega-retirada`, cfg);
    } catch (error) {
        const [e] = error;
        return { errors: e.message };
    }
};

const excludeTime = async ({
    idTipoEntregaRetirada,
    idHorarioEntregaRetirada
}) => {
    try {
        return Api.delete(
            `gestao/tipo-entrega-retirada/${idTipoEntregaRetirada}/horario/${idHorarioEntregaRetirada}`
        );
    } catch (error) {
        const [e] = error;
        return { errors: e.message };
    }
};

const addTime = async ({ idTipoEntregaRetirada, tpDiaSemana, horarios }) => {
    return Api.patch(
        `gestao/tipo-entrega-retirada/${idTipoEntregaRetirada}/dia/${tpDiaSemana}/horario`,
        horarios
    );
};

const inactiveDay = ({ idTipoEntregaRetirada, tpDiaSemana, fgAtivo }) => {
    const body = { fgAtivo };
    return Api.patch(
        `gestao/tipo-entrega-retirada/${idTipoEntregaRetirada}/dia/${tpDiaSemana}`,
        body
    );
};

const getFrete = () => {
    return Api.get(`gestao/tipo-condicao-frete`);
};

const createCondicaoFrete = (idTipoCobrancaFrete, condicaoFrete) => {
    return Api.post(
        `gestao/tipo-condicao-frete/${idTipoCobrancaFrete}/condicao-frete`,
        condicaoFrete
    );
};

const deleteCondicaoFrete = (idTipoCobrancaFrete, idCondicaoFrete) => {
    return Api.delete(
        `gestao/tipo-condicao-frete/${idTipoCobrancaFrete}/condicao-frete/${idCondicaoFrete}`
    );
};

const activeTipoCondicao = (idTipoCobrancaFrete) => {
    return Api.put(`gestao/tipo-condicao-frete/${idTipoCobrancaFrete}/ativa`);
};

export {
    getHorarios,
    getCfg,
    saveCfg,
    excludeTime,
    addTime,
    inactiveDay,
    getFrete,
    createCondicaoFrete,
    deleteCondicaoFrete,
    activeTipoCondicao
};
